import { compose } from 'lodash/fp';
import { paletteLookup, paletteValidator, highlightPaletteValidator } from './functions';
import getBackgroundPalette from './background';
import { generateTextTheme } from './text';
import border from './borders';

export function generateTheme(name, primaryPalette, accentPalette, highlightPalette) {
   const normalPaletteValidator = paletteValidator(100, 900);
   const highlightValidator = highlightPaletteValidator('primary', 'secondary');
   const getPrimaryColor = compose(paletteLookup(primaryPalette), normalPaletteValidator);
   const getAccentColor = compose(paletteLookup(accentPalette), normalPaletteValidator);
   const getHighlightColor = compose(paletteLookup(highlightPalette), highlightValidator);

   return Object.freeze({
      name: name,
      palettes: {
         primary: getPrimaryColor,
         accent: getAccentColor,
         highlight: getHighlightColor,
         background: getBackgroundPalette
      },
      text: generateTextTheme(getPrimaryColor, getAccentColor),
      border
   });
}



// WEBPACK FOOTER //
// ./src/UI/themes/generator.js